import { post } from "services/network/endpoint"
import { setAuthorizationBff } from "services/network/auth"
import { success } from "services/utils/action"
import { setCookie, getCookie } from "services/utils/cookie"
import { BFF } from "services/network/routes"
import * as ActionTypes from "../action-types"
import ENV from "../../../envProperties"
import _get from "lodash/get"

export function logout() {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.LOGOUT
    })

    window.location.href = `/AreaClienteCorporativo/logoff`
  }
}

export function restoreCredentials() {
  return (dispatch) => {
    return dispatch({
      type: ActionTypes.RESTORE_CREDENTIALS,
      payload: {
        userName: getCookie("userName")
      }
    })
  }
}

export function redirectToAuthorization(callbackLocation) {
  return () => {
    window.location.href = `${ENV.BFF}/auth/oauth2/authorization?location=${callbackLocation}`
  }
}

export function authenticate(data, callback, errorCallback) {
  return (dispatch) => {
    const request = post("authenticate", {
      data,
      client: BFF
    })

    dispatch({
      type: ActionTypes.AUTHENTICATE,
      payload: request
    }).then(
      success(({ payload }) => {
        if (!_get(payload, "data.user", null)) {
          errorCallback(payload)
        }
        const emBase64 = btoa(payload.data.user)

        setCookie("customerKey", emBase64)
        setCookie("userName", payload.data.user)

        setAuthorizationBff(payload)

        dispatch(restoreCredentials())

        callback && callback(payload)

        dispatch({ type: ActionTypes.AUTHENTICATION_PROCESSING_END })
      })
    )
  }
}

export function createProtocol(payload) {
  return (dispatch) => {
    const config = {
      data: payload,
      client: BFF
    }

    const request = post("protocol", config)

    return dispatch({
      type: ActionTypes.CREATE_PROTOCOL,
      payload: request
    })
  }
}

export function createInteraction(payload) {
  return (dispatch) => {
    const config = {
      data: payload,
      client: BFF
    }

    const request = post("interaction", config)

    return dispatch({
      type: ActionTypes.CREATE_INTERACTION,
      payload: request
    })
  }
}

export function sendEmailProtocol(payload) {
  return (dispatch) => {
    const config = {
      data: payload,
      client: BFF
    }

    const request = post("sendEmailProtocol", config)

    return dispatch({
      type: ActionTypes.SEND_MAIL_PROTOCOL,
      payload: request
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/state/auth/action.js